import axios from "axios";
import { createHelpers } from "vuex-map-fields";

import {
  dataTableActionsFactory,
  dataTableMutations,
  dataTableState
} from "@/store/abstracts/dataTableStores";

import { UPLOAD_LOGO, SEARCH, EXPORTS } from "@/store/action-types";

import { RESET_STATE, TOGGLE_LOADING, ERROR } from "../../mutation-types";

// The API util is used to send the
// data the Export enters to our server.
import {
  RepositoryFactory,
  FILES_REPOSITORY,
  EXPORTS_REPOSITORY
} from "@/utils/RepositoryFactory";
const FilesRepository = RepositoryFactory.get(FILES_REPOSITORY);
const ExportsRepository = RepositoryFactory.get(EXPORTS_REPOSITORY);

// Models are used to prepare
// store data to be sent to an API.
// import { Export } from "@/models/Export";
import { Exports } from "@/models/Exports";

// We're using reusable form modules
// to store the data of our forms.
import createForm from "./forms/create";
import searchForm from "./forms/search";

const getDefaultState = () => ({
  ...dataTableState
});

const state = getDefaultState();

let call;

const actions = {
  ...dataTableActionsFactory({
    repository: ExportsRepository,
    model: Exports,
    drawerName: "exports"
  }),
  async [UPLOAD_LOGO]({ commit }, { file }) {
    try {
      commit(TOGGLE_LOADING, true);

      const { data } = await FilesRepository.uploadFile({ file });

      commit(TOGGLE_LOADING, false);
      return data.content.url;
    } catch (error) {
      commit(`app/${ERROR}`, { error, message: error.message }, { root: true });
    }

    commit(TOGGLE_LOADING, false);
  },
  async [EXPORTS]({ commit }, { item }) {
    try {
      commit(TOGGLE_LOADING, true);

      const { data } = await ExportsRepository.download({ item });

      commit(TOGGLE_LOADING, false);
      return data.content;
    } catch (error) {
      commit(`app/${ERROR}`, { error, message: error.message }, { root: true });
    }

    commit(TOGGLE_LOADING, false);
  },
  async [SEARCH]({ commit }, { search = {} } = {}) {
    let searchQuery = search.query;

    if (!searchQuery || searchQuery.length < 2) {
      return [];
    }

    if (call) {
      call.cancel("Only one request allowed at a time.");
    }

    let repository;

    // switch (subfield) {
    //   case FIELD_SOCIETE:
    //     repository = SocietesRepository;
    //     break;
    //   case FIELD_FILIALE:
    //     repository = FilialesRepository;
    //     break;
    //   case FIELD_GROUPE:
    //     repository = GroupesRepository;
    //     break;
    //   default:
    //     repository = CompaniesRepository;
    // }

    repository = ExportsRepository;

    call = axios.CancelToken.source();

    try {
      const res = await repository.get({
        page: 1,
        searchQuery,
        cancelToken: call.token
      });

      const { data } = res;

      return data.content.list;
    } catch (error) {
      if (!axios.isCancel(error)) {
        commit(
          `app/${ERROR}`,
          { error, message: error.message },
          { root: true }
        );
      }
    }
  }
};

const mutations = {
  ...dataTableMutations,
  [RESET_STATE](state) {
    Object.assign(state, getDefaultState());
  }
};

const modules = {
  createForm,
  searchForm
};

// We're exporting Export field mapper
// functions for mapping form fields to Vuex.
// See: https://github.com/maoberlehner/vuex-map-fields#custom-getters-and-mutations

// export const FIELD_SOCIETE = "FIELD_SOCIETE";
// export const FIELD_FILIALE = "FIELD_FILIALE";
// export const FIELD_GROUPE = "FIELD_GROUPE";

export const {
  mapFields: mapExportsCreateFormFields,
  mapMultiRowFields: mapExportsCreateFormMultiRowFields
} = createHelpers({
  getterType: `exports/createForm/getField`,
  mutationType: `exports/createForm/updateField`
});

export const { mapFields: mapExportsSearchFormFields } = createHelpers({
  getterType: `exports/searchForm/getField`,
  mutationType: `exports/searchForm/updateField`
});

export default {
  namespaced: true,
  actions,
  mutations,
  state,
  modules
};
